import isEmpty from 'lodash/isEmpty';
import { z } from 'zod';

import { documentDataSchema } from '@/features/ui/DocumentsData/model/schemas';

import { zodArrayOptional, zodSelectOption, zodStringRequired } from '@/shared/lib/validations';

import { YesNoSelectOptions } from '@/components/Forms/constants';

import { InsuranceTabKeys } from './types';

export const insuranceBaseSchema = z.object({
  confirmInsuranceDoc: zodSelectOption,
  confirmInsuranceActiveTabKey: zodStringRequired,
  selectedInsurances: zodArrayOptional(z.any()),
  insuranceDocumentMetadata: z.any().optional(),
  confirmInsuranceDocuments: documentDataSchema.optional(),
});

export const insuranceDataSchema = insuranceBaseSchema.superRefine((data, ctx) => {
  if (data.confirmInsuranceDoc?.id === YesNoSelectOptions.NO.id) return;

  if (data.confirmInsuranceActiveTabKey === InsuranceTabKeys.ORDER) {
    if (isEmpty(data.selectedInsurances)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['selectedInsurances'],
        message: 'Необхідно вибрати поліс',
      });
    }
  }
});
